define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var ActionTypes;
    (function (ActionTypes) {
        ActionTypes["UNKNOWN"] = "UNKNOWN";
        ActionTypes["INIT_STATE"] = "INIT STATE";
        ActionTypes["INIT_STATE_SUCCESS"] = "INIT STATE SUCCESS";
        ActionTypes["INIT_STATE_ERROR"] = "INIT STATE ERROR";
        ActionTypes["GO_TO_PAGE"] = "GO TO PAGE";
        ActionTypes["LOADING_START"] = "LOADING START";
        ActionTypes["LOADING_END"] = "LOADING END";
        ActionTypes["NOTIFICATION_SHOW"] = "NOTIFICATION SHOW";
        ActionTypes["NOTIFICATION_CLOSE"] = "NOTIFICATION CLOSE";
        ActionTypes["LOGIN_SUBMIT"] = "LOGIN SUBMITTED";
        ActionTypes["LOGIN_SUCCESS"] = "LOGIN SUCCESS";
        ActionTypes["LOGIN_ERROR"] = "LOGIN ERROR";
        ActionTypes["REGISTER_SUBMIT"] = "REGISTER SUBMITTED";
        ActionTypes["REGISTER_SUCCESS"] = "REGISTER SUCCESS";
        ActionTypes["REGISTER_ERROR"] = "REGISTER ERROR";
        ActionTypes["EMAIL_SUBMIT"] = "EMAIL SUBMITTED";
        ActionTypes["EMAIL_SUBMIT_SUCCESS"] = "EMAIL SUBMIT SUCCESS";
        ActionTypes["EMAIL_SUBMIT_ERROR"] = "EMAIL SUBMIT ERROR";
        ActionTypes["PASSWORD_CONFIRM_SUBMIT"] = "PASSWORD SUBMITTED";
        ActionTypes["PASSWORD_CONFIRM_SUCCESS"] = "PASSWORD SUBMIT SUCCESS";
        ActionTypes["PASSWORD_CONFIRM_ERROR"] = "PASSWORD SUBMIT ERROR";
        ActionTypes["POST_CAR_DATA"] = "POST CAR DATA";
        ActionTypes["POST_CAR_DATA_SUCCESS"] = "POST CAR DATA SUCCESS";
        ActionTypes["POST_CAR_DATA_ERROR"] = "POST CAR DATA ERROR";
        ActionTypes["POST_CAR_ONLY"] = "POST CAR ONLY";
        ActionTypes["POST_CAR_ONLY_SUCCESS"] = "POST CAR ONLY SUCCESS";
        ActionTypes["POST_CAR_ONLY_ERROR"] = "POST CAR ONLY ERROR";
        ActionTypes["POST_CAR_ONLY_AND_CONTINUE"] = "POST CAR ONLY AND CONTINUE";
        ActionTypes["POST_CAR_ONLY_AND_CONTINUE_SUCCESS"] = "POST CAR ONLY AND CONTINUE SUCCESS";
        ActionTypes["POST_CAR_ONLY_AND_CONTINUE_ERROR"] = "POST CAR ONLY AND CONTINUE ERROR";
        ActionTypes["GET_CAR_DATA"] = "GET CAR DATA";
        ActionTypes["GET_CAR_DATA_SUCCESS"] = "GET CAR DATA SUCCESS";
        ActionTypes["GET_CAR_DATA_ERROR"] = "GET CAR DATA ERROR";
        ActionTypes["SELL_CAR_WITHOUT_WARRANTY"] = "SELL CAR WITHOUT WARRANTY";
        ActionTypes["SELL_CAR_WITHOUT_WARRANTY_SUCCESS"] = "SELL CAR WITHOUT WARRANTY SUCCESS";
        ActionTypes["SELL_CAR_WITHOUT_WARRANTY_ERROR"] = "SELL CAR WITHOUT WARRANTY ERROR";
        ActionTypes["GET_CAR_MODELS"] = "GET CAR MODELS";
        ActionTypes["GET_CAR_MODELS_SUCCESS"] = "GET CAR MODELS SUCCESS";
        ActionTypes["GET_CAR_MODELS_ERROR"] = "GET CAR MODELS ERROR";
        ActionTypes["GET_CAR"] = "GET CAR";
        ActionTypes["GET_CAR_SUCCESS"] = "GET CAR SUCCESS";
        ActionTypes["GET_CAR_ERROR"] = "GET CAR ERROR";
        ActionTypes["SAVE_PACKAGE"] = "SAVE PACKAGE ID";
        ActionTypes["SAVE_EXTRA_PACKAGE"] = "SAVE EXTRA PACKAGE ID";
        ActionTypes["REMOVE_EXTRA_PACKAGE"] = "REMOVE EXTRA PACKAGE ID";
        ActionTypes["CLEAR_SELECTED_EXTRA_PACKAGES"] = "CLEAR_SELECTED_EXTRA_PACKAGES";
        ActionTypes["GET_PACKAGES"] = "GET PACKAGES";
        ActionTypes["GET_PACKAGES_SUCCESS"] = "GET PACKAGES SUCCESS";
        ActionTypes["GET_PACKAGES_ERROR"] = "GET PACKAGES ERROR";
        ActionTypes["GET_EXTRA_PACKAGES"] = "GET EXTRA PACKAGES";
        ActionTypes["GET_EXTRA_PACKAGES_SUCCESS"] = "GET EXTRA PACKAGES SUCCESS";
        ActionTypes["GET_EXTRA_PACKAGES_ERROR"] = "GET EXTRA PACKAGES ERROR";
        ActionTypes["GET_CAR_PROBLEM_EXTRA_PACKAGE"] = "GET CAR PROBLEM EXTRA PACKAGE";
        ActionTypes["GET_CAR_PROBLEM_EXTRA_PACKAGE_SUCCESS"] = "GET CAR PROBLEM EXTRA PACKAGE SUCCESS";
        ActionTypes["GET_CAR_PROBLEM_EXTRA_PACKAGE_ERROR"] = "GET CAR PROBLEM EXTRA PACKAGE ERROR";
        ActionTypes["SAVE_WARRANTY"] = "SAVE WARRANTY";
        ActionTypes["SAVE_WARRANTY_SUCCESS"] = "SAVE WARRANTY SUCCESS";
        ActionTypes["SAVE_WARRANTY_ERROR"] = "SAVE WARRANTY ERROR";
        ActionTypes["SAVE_WARRANTY_ONLY"] = "SAVE WARRANTY ONLY";
        ActionTypes["SAVE_WARRANTY_ONLY_SUCCESS"] = "SAVE WARRANTY ONLY SUCCESS";
        ActionTypes["SAVE_WARRANTY_ONLY_ERROR"] = "SAVE WARRANTY ONLY ERROR";
        ActionTypes["DELETE_WARRANTY"] = "DELETE WARRANTY";
        ActionTypes["DELETE_WARRANTY_SUCCESS"] = "DELETE WARRANTY SUCCESS";
        ActionTypes["DELETE_WARRANTY_ERROR"] = "DELETE WARRANTY ERROR";
        ActionTypes["GET_WARRANTIES"] = "GET WARRANTIES";
        ActionTypes["GET_WARRANTIES_SUCCESS"] = "GET WARRANTIES SUCCESS";
        ActionTypes["GET_WARRANTIES_ERROR"] = "GET WARRANTIES ERROR";
        ActionTypes["SELL_CAR"] = "SELL CAR";
        ActionTypes["SELL_CAR_SUCCESS"] = "SELL CAR SUCCESS";
        ActionTypes["SELL_CAR_ERROR"] = "SELL CAR ERROR";
        ActionTypes["DEACTIVATE_CAR"] = "DEACTIVATE CAR";
        ActionTypes["DEACTIVATE_CAR_SUCCESS"] = "DEACTIVATE CAR SUCCESS";
        ActionTypes["DEACTIVATE_CAR_ERROR"] = "DEACTIVATE CAR ERROR";
        ActionTypes["ACTIVATE_CAR"] = "ACTIVATE CAR";
        ActionTypes["ACTIVATE_CAR_SUCCESS"] = "ACTIVATE CAR SUCCESS";
        ActionTypes["ACTIVATE_CAR_ERROR"] = "ACTIVATE CAR ERROR";
        ActionTypes["GET_BUYER_BY_CAR_ID"] = "GET BUYER BY CAR ID";
        ActionTypes["GET_BUYER_BY_CAR_ID_SUCCESS"] = "GET BUYER BY CAR ID SUCCESS";
        ActionTypes["GET_BUYER_BY_CAR_ID_ERROR"] = "GET BUYER BY CAR ID ERROR";
        ActionTypes["GET_BUYER_BY_OIB"] = "GET BUYER BY OIB";
        ActionTypes["GET_BUYER_BY_OIB_SUCCESS"] = "GET BUYER BY OIB SUCCESS";
        ActionTypes["GET_BUYER_BY_OIB_ERROR"] = "GET BUYER BY OIB ERROR";
        ActionTypes["GET_BUYER_BY_EMAIL"] = "GET BUYER BY EMAIL";
        ActionTypes["GET_BUYER_BY_EMAIL_SUCCESS"] = "GET BUYER BY EMAIL SUCCESS";
        ActionTypes["GET_BUYER_BY_EMAIL_ERROR"] = "GET BUYER BY EMAIL ERROR";
        ActionTypes["GET_WARRANTY_STATUSES"] = "GET WARRANTY STATUSES";
        ActionTypes["GET_WARRANTY_STATUSES_SUCCESS"] = "GET WARRANTY STATUSES SUCCESS";
        ActionTypes["GET_WARRANTY_STATUSES_ERROR"] = "GET WARRANTY STATUSES ERROR";
        ActionTypes["UPDATE_WARRANTY_STATUS"] = "UPDATE WARRANTY STATUS";
        ActionTypes["UPDATE_WARRANTY_STATUS_SUCCESS"] = "UPDATE WARRANTY STATUS SUCCESS";
        ActionTypes["UPDATE_WARRANTY_STATUS_ERROR"] = "UPDATE WARRANTY STATUS ERROR";
        ActionTypes["GET_WARRANTY"] = "GET WARRANTY";
        ActionTypes["GET_WARRANTY_SUCCESS"] = "GET WARRANTY SUCCESS";
        ActionTypes["GET_WARRANTY_ERROR"] = "GET WARRANTY ERROR";
        ActionTypes["GET_LEGAL_ENTITIES"] = "GET LEGAL ENTITIES";
        ActionTypes["GET_LEGAL_ENTITIES_SUCCESS"] = "GET LEGAL ENTITIES SUCCESS";
        ActionTypes["GET_LEGAL_ENTITIES_ERROR"] = "GET LEGAL ENTITIES ERROR";
        ActionTypes["SAVE_SELLER"] = "SAVE SELLER";
        ActionTypes["SAVE_SELLER_SUCCESS"] = "SAVE SELLER SUCCESS";
        ActionTypes["SAVE_SELLER_ERROR"] = "SAVE SELLER ERROR";
        ActionTypes["CHANGE_SELLER"] = "CHANGE SELLER";
        ActionTypes["CHANGE_SELLER_SUCCESS"] = "CHANGE SELLER SUCCESS";
        ActionTypes["CHANGE_SELLER_ERROR"] = "CHANGE SELLER ERROR";
        ActionTypes["CHANGE_BUYER"] = "CHANGE BUYER";
        ActionTypes["CHANGE_BUYER_SUCCESS"] = "CHANGE BUYER SUCCESS";
        ActionTypes["CHANGE_BUYER_ERROR"] = "CHANGE BUYER ERROR";
        ActionTypes["ACTIVATE_SELLER"] = "ACTIVATE SELLER";
        ActionTypes["ACTIVATE_SELLER_SUCCESS"] = "ACTIVATE SELLER SUCCESS";
        ActionTypes["ACTIVATE_SELLER_ERROR"] = "ACTIVATE SELLER ERROR";
        ActionTypes["DELETE_SELLER"] = "DELETE SELLER";
        ActionTypes["DELETE_SELLER_SUCCESS"] = "DELETE SELLER SUCCESS";
        ActionTypes["DELETE_SELLER_ERROR"] = "DELETE SELLER ERROR";
        ActionTypes["GET_ADMIN_TABLE_DATA"] = "GET ADMIN TABLE DATA";
        ActionTypes["GET_ADMIN_TABLE_DATA_SUCCESS"] = "GET ADMIN TABLE DATA SUCCESS";
        ActionTypes["GET_ADMIN_TABLE_DATA_ERROR"] = "GET ADMIN TABLE DATA ERROR";
        ActionTypes["GET_ADMIN_ARCHIVE_TABLE_DATA"] = "GET ADMIN ARCHIVE TABLE DATA";
        ActionTypes["GET_ADMIN_ARCHIVE_TABLE_DATA_SUCCESS"] = "GET ADMIN ARCHIVE TABLE DATA SUCCESS";
        ActionTypes["GET_ADMIN_ARCHIVE_TABLE_DATA_ERROR"] = "GET ADMIN ARCHIVE TABLE DATA ERROR";
        ActionTypes["SAVE_NJUSKALO_SELLER"] = "SAVE NJUSKALO SELLER";
        ActionTypes["SAVE_NJUSKALO_SELLER_SUCCESS"] = "SAVE NJUSKALO SELLER SUCCESS";
        ActionTypes["SAVE_NJUSKALO_SELLER_ERROR"] = "SAVE NJUSKALO SELLER ERROR";
        ActionTypes["GET_NJUSKALO_SELLER"] = "GET_NJUSKALO_SELLER";
        ActionTypes["GET_NJUSKALO_SELLER_SUCCESS"] = "GET_NJUSKALO_SELLER_SUCCESS";
        ActionTypes["GET_NJUSKALO_SELLER_ERROR"] = "GET_NJUSKALO_SELLER_ERROR";
        ActionTypes["CLEAR_NJUSKALO_SELLER"] = "CLEAR NJUSKALO SELLER";
        ActionTypes["GET_CURRENT_USER"] = "GET CURRENT USER";
        ActionTypes["GET_CURRENT_USER_ERROR"] = "GET CURRENT USER ERROR";
        ActionTypes["GET_CURRENT_USER_SUCCESS"] = "GET CURRENT USER SUCCESS";
        ActionTypes["CONFIRM_DATA"] = "CONFIRM DATA";
        ActionTypes["CONFIRM_DATA_SUCCESS"] = "CONFIRM DATA SUCCESS";
        ActionTypes["CONFIRM_DATA_ERROR"] = "CONFIRM DATA ERROR";
        ActionTypes["GET_DAMAGE"] = "GET DAMAGE";
        ActionTypes["GET_DAMAGE_SUCCESS"] = "GET DAMAGE SUCCESS";
        ActionTypes["GET_DAMAGE_ERROR"] = "GET DAMAGE ERROR";
        ActionTypes["GET_ACTIVE_DAMAGE"] = "GET ACTIVE DAMAGE";
        ActionTypes["GET_ACTIVE_DAMAGE_SUCCESS"] = "GET ACTIVE DAMAGE SUCCESS";
        ActionTypes["GET_ACTIVE_DAMAGE_ERROR"] = "GET ACTIVE DAMAGE ERROR";
        ActionTypes["GET_DAMAGE_STATUSES"] = "GET DAMAGE STATUSES";
        ActionTypes["GET_DAMAGE_STATUSES_SUCCESS"] = "GET DAMAGE STATUSES SUCCESS";
        ActionTypes["GET_DAMAGE_STATUSES_ERROR"] = "GET DAMAGE STATUSES ERROR";
        ActionTypes["SAVE_DAMAGE"] = "SAVE DAMAGE";
        ActionTypes["SAVE_DAMAGE_SUCCESS"] = "SAVE DAMAGE SUCCESS";
        ActionTypes["SAVE_DAMAGE_ERROR"] = "SAVE DAMAGE ERROR";
        ActionTypes["GET_DAMAGES_ADMIN"] = "GET DAMAGES ADMIN";
        ActionTypes["GET_DAMAGES_ADMIN_SUCCESS"] = "GET DAMAGES ADMIN SUCCESS";
        ActionTypes["GET_DAMAGES_ADMIN_ERROR"] = "GET DAMAGES ADMIN ERROR";
        ActionTypes["GET_CARS_ADMIN"] = "GET CARS ADMIN";
        ActionTypes["GET_CARS_ADMIN_SUCCESS"] = "GET CARS ADMIN SUCCESS";
        ActionTypes["GET_CARS_ADMIN_ERROR"] = "GET CARS ADMIN ERROR";
        ActionTypes["GET_CARS_DROPDOWN_ADMIN"] = "GET CARS DROPDOWN ADMIN";
        ActionTypes["GET_CARS_DROPDOWN_ADMIN_SUCCESS"] = "GET CARS DROPDOWN ADMIN SUCCESS";
        ActionTypes["GET_CARS_DROPDOWN_ADMIN_ERROR"] = "GET CARS DROPDOWN ADMIN ERROR";
        ActionTypes["GET_CARS_ADMIN_ONLY_CARS"] = "GET CARS ADMIN ONLY CARS";
        ActionTypes["GET_CARS_ADMIN_ONLY_CARS_SUCCESS"] = "GET CARS ADMIN ONLY CARS SUCCESS";
        ActionTypes["GET_CARS_ADMIN_ONLY_CARS_ERROR"] = "GET CARS ADMIN ONLY CARS ERROR";
        ActionTypes["GET_CARS_ADMIN_SOLD_ONLY_CARS"] = "GET CARS ADMIN SOLD ONLY CARS";
        ActionTypes["GET_CARS_ADMIN_SOLD_ONLY_CARS_SUCCESS"] = "GET CARS ADMIN SOLD ONLY CARS SUCCESS";
        ActionTypes["GET_CARS_ADMIN_SOLD_ONLY_CARS_ERROR"] = "GET CARS ADMIN SOLD ONLY CARS ERROR";
        ActionTypes["GET_CARS_SELLER"] = "GET CARS SELLER";
        ActionTypes["GET_CARS_SELLER_SUCCESS"] = "GET CARS SELLER SUCCESS";
        ActionTypes["GET_CARS_SELLER_ERROR"] = "GET CARS SELLER ERROR";
        ActionTypes["GET_CARS_DROPDOWN_SELLER"] = "GET CARS DROPDOWN SELLER";
        ActionTypes["GET_CARS_DROPDOWN_SELLER_SUCCESS"] = "GET CARS DROPDOWN SELLER SUCCESS";
        ActionTypes["GET_CARS_DROPDOWN_SELLER_ERROR"] = "GET CARS DROPDOWN SELLER ERROR";
        ActionTypes["CHANGE_SELLER_EMAIL"] = "CHANGE SELLER EMAIL";
        ActionTypes["CHANGE_SELLER_EMAIL_SUCCESS"] = "CHANGE SELLER EMAIL SUCCESS";
        ActionTypes["CHANGE_SELLER_EMAIL_ERROR"] = "CHANGE SELLER EMAIL ERROR";
        ActionTypes["GET_DAMAGES_SELLER"] = "GET DAMAGES SELLER";
        ActionTypes["GET_DAMAGES_SELLER_SUCCESS"] = "GET DAMAGES SELLER SUCCESS";
        ActionTypes["GET_DAMAGES_SELLER_ERROR"] = "GET DAMAGES SELLER ERROR";
        ActionTypes["GET_DAMAGES_BUYER"] = "GET DAMAGES BUYER";
        ActionTypes["GET_DAMAGES_BUYER_SUCCESS"] = "GET DAMAGES BUYER SUCCESS";
        ActionTypes["GET_DAMAGES_BUYER_ERROR"] = "GET DAMAGES BUYER ERROR";
        ActionTypes["GET_DAMAGES_CAR"] = "GET DAMAGES CAR";
        ActionTypes["GET_DAMAGES_CAR_SUCCESS"] = "GET DAMAGES CAR SUCCESS";
        ActionTypes["GET_DAMAGES_CAR_ERROR"] = "GET DAMAGES CAR ERROR";
        ActionTypes["GET_DAMAGES_WARRANTY"] = "GET DAMAGES WARRANTY";
        ActionTypes["GET_DAMAGES_WARRANTY_SUCCESS"] = "GET DAMAGES WARRANTY SUCCESS";
        ActionTypes["GET_DAMAGES_WARRANTY_ERROR"] = "GET DAMAGES WARRANTY ERROR";
        ActionTypes["GET_DAMAGES_SELLERBYADMIN"] = "GET DAMAGES SELLERBYADMIN";
        ActionTypes["GET_DAMAGES_SELLERBYADMIN_SUCCESS"] = "GET DAMAGES SELLERBYADMIN SUCCESS";
        ActionTypes["GET_DAMAGES_SELLERBYADMIN_ERROR"] = "GET DAMAGES SELLERBYADMIN ERROR";
        ActionTypes["GET_CHASSIS_DAMAGE"] = "GET CHASSIS DAMAGE";
        ActionTypes["GET_CHASSIS_DAMAGE_SUCCESS"] = "GET CHASSIS DAMAGE SUCCESS";
        ActionTypes["GET_CHASSIS_DAMAGE_ERROR"] = "GET CHASSIS DAMAGE ERROR";
        ActionTypes["GET_CHASSIS_CAR"] = "GET CHASSIS CAR";
        ActionTypes["GET_CHASSIS_CAR_SUCCESS"] = "GET CHASSIS CAR SUCCESS";
        ActionTypes["GET_CHASSIS_CAR_ERROR"] = "GET CHASSIS CAR ERROR";
        ActionTypes["DELETE_DAMAGE"] = "DELETE DAMAGE";
        ActionTypes["DELETE_DAMAGE_SUCCESS"] = "DELETE DAMAGE SUCCESS";
        ActionTypes["DELETE_DAMAGE_ERROR"] = "DELETE DAMAGE ERROR";
        ActionTypes["SAVE_PHOTOS"] = "SAVE PHOTOS";
        ActionTypes["REVIEW_CAR"] = "REVIEW CAR";
        ActionTypes["REVIEW_CAR_SUCCESS"] = "REVIEW CAR SUCCESS";
        ActionTypes["REVIEW_CAR_ERROR"] = "REVIEW CAR ERROR";
        ActionTypes["GET_BUYERS"] = "GET BUYERS";
        ActionTypes["GET_BUYERS_SUCCESS"] = "GET BUYERS SUCCESS";
        ActionTypes["GET_BUYERS_ERROR"] = "GET BUYERS ERROR";
        ActionTypes["GET_BUYER"] = "GET BUYER";
        ActionTypes["GET_BUYER_SUCCESS"] = "GET BUYER SUCCESS";
        ActionTypes["GET_BUYER_ERROR"] = "GET BUYER ERROR";
        ActionTypes["SAVE_BUYER"] = "SAVE BUYER";
        ActionTypes["SAVE_BUYER_SUCCESS"] = "SAVE BUYER SUCCESS";
        ActionTypes["SAVE_BUYER_ERROR"] = "SAVE BUYER ERROR";
        ActionTypes["DELETE_BUYER"] = "DELETE BUYER";
        ActionTypes["DELETE_BUYER_SUCCESS"] = "DELETE BUYER SUCCESS";
        ActionTypes["DELETE_BUYER_ERROR"] = "DELETE BUYER ERROR";
        ActionTypes["ACTIVATE_BUYER"] = "ACTIVATE BUYER";
        ActionTypes["ACTIVATE_BUYER_SUCCESS"] = "ACTIVATE BUYER SUCCESS";
        ActionTypes["ACTIVATE_BUYER_ERROR"] = "ACTIVATE BUYER ERROR";
        ActionTypes["GET_SELLERS"] = "GET SELLERS";
        ActionTypes["GET_SELLERS_SUCCESS"] = "GET SELLERS SUCCESS";
        ActionTypes["GET_SELLERS_ERROR"] = "GET SELLERS ERROR";
        ActionTypes["GET_SELLER"] = "GET SELLER";
        ActionTypes["GET_SELLER_SUCCESS"] = "GET SELLER SUCCESS";
        ActionTypes["GET_SELLER_ERROR"] = "GET SELLER ERROR";
        ActionTypes["CLEAR_SELLER"] = "CLEAR SELLER";
        ActionTypes["GET_CURRENT_CAR_REVIEW"] = "GET CURRENT CAR REVIEW";
        ActionTypes["GET_CURRENT_CAR_REVIEW_SUCCESS"] = "GET CURRENT CAR REVIEW SUCCESS";
        ActionTypes["GET_CURRENT_CAR_REVIEW_ERROR"] = "GET CURRENT CAR REVIEW ERROR";
        ActionTypes["ACTIVATE_WARRANTY"] = "ACTIVATE WARRANTY";
        ActionTypes["ACTIVATE_WARRANTY_SUCCESS"] = "ACTIVATE WARRANTY SUCCESS";
        ActionTypes["ACTIVATE_WARRANTY_ERROR"] = "ACTIVATE WARRANTY ERROR";
        ActionTypes["CHECK_WARRANTIES_FOR_ACTIVATION"] = "CHECK WARRANTIES FOR ACTIVATION";
        ActionTypes["CHECK_WARRANTIES_FOR_ACTIVATION_SUCCESS"] = "CHECK WARRANTIES FOR ACTIVATION SUCCESS";
        ActionTypes["CHECK_WARRANTIES_FOR_ACTIVATION_ERROR"] = "CHECK WARRANTIES FOR ACTIVATION ERROR";
        ActionTypes["GET_WARRANTY_FOR_CONTRACT"] = "GET WARRANTY FOR CONTRACT";
        ActionTypes["GET_WARRANTY_FOR_CONTRACT_SUCCESS"] = "GET WARRANTY FOR CONTRACT SUCCESS";
        ActionTypes["GET_WARRANTY_FOR_CONTRACT_ERROR"] = "GET WARRANTY FOR CONTRACT ERROR";
        ActionTypes["EDIT_MISSING_CAR_DETAILS"] = "EDIT MISSING CAR DETAILS";
        ActionTypes["SET_IS_MISSING_CAR_DETAILS"] = "SET IS MISSING CAR DETAILS";
        ActionTypes["GET_THIS_MONTH_SOLD_STATISTIC"] = "GET THIS MONTH SOLD STATISTIC";
        ActionTypes["GET_THIS_MONTH_SOLD_STATISTIC_SUCCESS"] = "GET THIS MONTH SOLD STATISTIC SUCCESS";
        ActionTypes["GET_THIS_MONTH_SOLD_STATISTIC_ERROR"] = "GET THIS MONTH SOLD STATISTIC ERROR";
        ActionTypes["GET_SOLD_STATISTIC"] = "GET SOLD STATISTIC";
        ActionTypes["GET_SOLD_STATISTIC_SUCCESS"] = "GET SOLD STATISTIC SUCCESS";
        ActionTypes["GET_SOLD_STATISTIC_ERROR"] = "GET SOLD STATISTIC ERROR";
        ActionTypes["GET_MARKETING_THIS_MONTH_SOLD_STATISTIC"] = "GET MARKETING THIS MONTH SOLD STATISTIC";
        ActionTypes["GET_MARKETING_THIS_MONTH_SOLD_STATISTIC_SUCCESS"] = "GET MARKETING THIS MONTH SOLD STATISTIC SUCCESS";
        ActionTypes["GET_MARKETING_THIS_MONTH_SOLD_STATISTIC_ERROR"] = "GET MARKETING THIS MONTH SOLD STATISTIC ERROR";
        ActionTypes["UPGRADE_WARRANTY_PACKGAGE"] = "UPGRADE WARRANTY PACKGAGE";
        ActionTypes["UPGRADE_WARRANTY_PACKGAGE_SUCCESS"] = "UPGRADE WARRANTY PACKGAGE SUCCESS";
        ActionTypes["UPGRADE_WARRANTY_PACKGAGE_ERROR"] = "UPGRADE WARRANTY PACKGAGE ERROR";
        ActionTypes["GET_CARS_FOR_SELLER"] = "GET CARS FOR SELLER";
        ActionTypes["GET_CARS_FOR_SELLER_SUCCESS"] = "GET CARS FOR SELLER SUCCESS";
        ActionTypes["GET_CARS_FOR_SELLER_ERROR"] = "GET CARS FOR SELLER ERROR";
        ActionTypes["CHANGE_SHOW_ON_PORTAL"] = "CHANGE SHOW ON PORTAL";
        ActionTypes["HIDE_ALL_CARS_ON_PORTAL"] = "HIDE_ALL_CARS_ON_PORTAL";
        ActionTypes["GET_CAR_DETAILS"] = "GET CAR DETAILS";
        ActionTypes["GET_CAR_DETAILS_SUCCESS"] = "GET CAR DETAILS SUCCESS";
        ActionTypes["GET_CAR_DETAILS_ERROR"] = "GET CAR DETAILS ERROR";
        ActionTypes["UPDATE_CAR_DETAILS"] = "UPDATE CAR DETAILS";
        ActionTypes["UPDATE_CAR_DETAILS_SUCCESS"] = "UPDATE CAR SUCCESS";
        ActionTypes["UPDATE_CAR_DETAILS_ERROR"] = "UPDATE CAR ERROR";
        ActionTypes["LOAD_MORE_CARS"] = "LOAD MORE CARS";
        ActionTypes["LOAD_MORE_FILTER_CARS_SUCCESS"] = "LOAD MORE FILTER CARS SUCCESS";
        ActionTypes["GET_CAR_BRANDS"] = "GET CAR BRANDS";
        ActionTypes["GET_CAR_BRANDS_SUCCESS"] = "GET CAR BRANDS SUCCESS";
        ActionTypes["GET_CAR_BRANDS_ERROR"] = "GET CAR BRANDS ERROR";
        ActionTypes["GET_CAR_MODELS_BY_BRAND"] = "GET CAR MODELS BY BRAND";
        ActionTypes["GET_CAR_MODELS_BY_BRAND_SUCCESS"] = "GET CAR MODELS BY BRAND SUCCESS";
        ActionTypes["GET_CAR_MODELS_BY_BRAND_ERROR"] = "GET CAR MODELS BY BRAND ERROR";
        ActionTypes["GET_ENGINE_TYPES"] = "GET ENGINE TYPES";
        ActionTypes["GET_ENGINE_TYPES_SUCCESS"] = "GET ENGINE TYPES SUCCESS";
        ActionTypes["GET_ENGINE_TYPES_ERROR"] = "GET ENGINE TYPES ERROR";
        ActionTypes["GET_SELLER_DROPDOWN_DATA"] = "GET SELLER DROPDOWN_DATA";
        ActionTypes["GET_SELLER_DROPDOWN_DATA_SUCCESS"] = "GET SELLER DROPDOWN DATA SUCCESS";
        ActionTypes["GET_SELLER_DROPDOWN_DATA_ERROR"] = "GET SELLER DROPDOWN DATA ERROR";
        ActionTypes["FILTER_CARS"] = "FILTER CARS";
        ActionTypes["FILTER_CARS_SUCCESS"] = "FILTER CARS SUCCESS";
        ActionTypes["FILTER_CARS_ERROR"] = "FILTER CARS ERROR";
        ActionTypes["SEND_INVOICE"] = "SEND INVOICE";
        ActionTypes["SEND_INVOICE_SUCCESS"] = "SEND INVOICE SUCCESS";
        ActionTypes["SEND_INVOICE_ERROR"] = "SEND INVOICE ERROR";
        ActionTypes["GET_INVOICES"] = "GET_INVOICES";
        ActionTypes["GET_INVOICES_SUCCESS"] = "GET_INVOICES SUCCESS";
        ActionTypes["GET_INVOICES_ERROR"] = "GET_INVOICES ERROR";
        ActionTypes["GET_YEARS"] = "GET YEARS";
        ActionTypes["GET_YEARS_SUCCESS"] = "GET YEARS SUCCESS";
        ActionTypes["GET_YEARS_ERROR"] = "GET YEARS ERROR";
        ActionTypes["GET_INVOICE"] = "GET INVOICE";
        ActionTypes["GET_INVOICE_SUCCESS"] = "GET INVOICE SUCCESS";
        ActionTypes["GET_INVOICE_ERROR"] = "GET INVOICE ERROR";
        ActionTypes["GET_LAST_INVOICE"] = "GET LAST INVOICE";
        ActionTypes["GET_LAST_INVOICE_SUCCESS"] = "GET LAST INVOICE SUCCESS";
        ActionTypes["GET_LAST_INVOICE_ERROR"] = "GET LAST INVOICE ERROR";
        ActionTypes["GET_SELLER_NAME"] = "GET SELLER NAME";
        ActionTypes["GET_SELLER_NAME_SUCCESS"] = "GET SELLER NAME SUCCESS";
        ActionTypes["GET_SELLER_NAME_ERROR"] = "GET SELLER NAME ERROR";
        ActionTypes["GET_BUYER_NAME"] = "GET BUYER NAME";
        ActionTypes["GET_BUYER_NAME_SUCCESS"] = "GET BUYER NAME SUCCESS";
        ActionTypes["GET_BUYER_NAME_ERROR"] = "GET BUYER NAME ERROR";
        ActionTypes["GET_CAR_NAME"] = "GET CAR NAME";
        ActionTypes["GET_CAR_NAME_SUCCESS"] = "GET CAR NAME SUCCESS";
        ActionTypes["GET_CAR_NAME_ERROR"] = "GET CAR NAME ERROR";
        ActionTypes["SAVE_NOTE_FOR_SELLER"] = "SAVE NOTE FOR SELLER";
        ActionTypes["SAVE_NOTE_FOR_SELLER_SUCCESS"] = "SAVE NOTE FOR SELLER SUCCESS";
        ActionTypes["SAVE_NOTE_FOR_SELLER_ERROR"] = "SAVE NOTE FOR SELLER ERROR";
        ActionTypes["IMPORT_CARS"] = "IMPORT CARS";
        ActionTypes["IMPORT_CARS_SUCCESS"] = "IMPORT CARS SUCCESS";
        ActionTypes["IMPORT_CARS_ERROR"] = "IMPORT CARS ERROR";
        ActionTypes["GET_WARRANTIES_FOR_BUYER"] = "GET_WARRANTIES_FOR_BUYER";
        ActionTypes["GET_WARRANTIES_FOR_BUYER_SUCCESS"] = "GET_WARRANTIES_FOR_BUYER_SUCCESS";
        ActionTypes["GET_WARRANTIES_FOR_BUYER_ERROR"] = "GET_WARRANTIES_FOR_BUYER ERROR";
        ActionTypes["GET_WARRANTIES_FOR_SELLER"] = "GET_WARRANTIES_FOR_SELLER";
        ActionTypes["GET_WARRANTIES_FOR_SELLER_SUCCESS"] = "GET_WARRANTIES_FOR_SELLER_SUCCESS";
        ActionTypes["GET_WARRANTIES_FOR_SELLER_ERROR"] = "GET_WARRANTIES_FOR_SELLER ERROR";
        ActionTypes["GET_CURRENCIES"] = "GET_CURRENCIES";
        ActionTypes["GET_CURRENCIES_SUCCESS"] = "GET_CURRENCIES_SUCCESS";
        ActionTypes["GET_CURRENCIES_ERROR"] = "GET_CURRENCIES_ERROR";
        ActionTypes["CHANGE_VALID_DATE"] = "CHANGE VALID DATE";
        ActionTypes["CHANGE_VALID_DATE_SUCCESS"] = "CHANGE VALID DATE SUCCESS";
        ActionTypes["CHANGE_VALID_DATE_ERROR"] = "CHANGE VALID DATE ERROR";
        ActionTypes["SEND_ACTIVATION_EMAIL_BUYER"] = "SEND ACTIVATION EMAIL BUYER";
        ActionTypes["SEND_ACTIVATION_EMAIL_BUYER_SUCCESS"] = "SEND ACTIVATION EMAIL BUYER SUCCESS";
        ActionTypes["SEND_ACTIVATION_EMAIL_BUYER_ERROR"] = "SEND ACTIVATION EMAIL BUYER ERROR";
        ActionTypes["SEND_WARRANTY_EMAIL"] = "SEND WARRANTY EMAIL";
        ActionTypes["SEND_WARRANTY_EMAIL_SUCCESS"] = "SEND WARRANTY EMAIL SUCCESS";
        ActionTypes["SEND_WARRANTY_EMAIL_ERROR"] = "SEND WARRANTY EMAIL ERROR";
        ActionTypes["GET_CARS_ADMIN_TOTAL_COUNT"] = "GET CARS ADMIN TOTAL COUNT";
        ActionTypes["GET_CARS_ADMIN_TOTAL_COUNT_SUCCESS"] = "GET CARS ADMIN TOTAL COUNT SUCCESS";
        ActionTypes["GET_CARS_ADMIN_TOTAL_COUNT_ERROR"] = "GET CARS ADMIN TOTAL COUNT ERROR";
        ActionTypes["GET_CARS_ADMIN_ONLY_CARS_TOTAL_COUNT"] = "GET CARS ADMIN ONLY CARS TOTAL COUNT";
        ActionTypes["GET_CARS_ADMIN_ONLY_CARS_TOTAL_COUNT_SUCCESS"] = "GET CARS ADMIN ONLY CARS TOTAL COUNT SUCCESS";
        ActionTypes["GET_CARS_ADMIN_ONLY_CARS_TOTAL_COUNT_ERROR"] = "GET CARS ADMIN ONLY CARS TOTAL COUNT ERROR";
        ActionTypes["GET_CARS_ADMIN_SOLD_ONLY_TOTAL_COUNT"] = "GET CARS ADMIN SOLD ONLY TOTAL COUNT";
        ActionTypes["GET_CARS_ADMIN_SOLD_ONLY_TOTAL_COUNT_SUCCESS"] = "GET CARS ADMIN SOLD ONLY TOTAL COUNT SUCCESS";
        ActionTypes["GET_CARS_ADMIN_SOLD_ONLY_TOTAL_COUNT_ERROR"] = "GET CARS ADMIN SOLD ONLY TOTAL COUNT ERROR";
        ActionTypes["GET_WARRANTY_ADMIN_TABLE_TOTAL_COUNT"] = "GET WARRANTY ADMIN TABLE TOTAL COUNT";
        ActionTypes["GET_WARRANTY_ADMIN_TABLE_TOTAL_COUNT_SUCCESS"] = "GET WARRANTY ADMIN TABLE TOTAL COUNT SUCCESS";
        ActionTypes["GET_WARRANTY_ADMIN_TABLE_TOTAL_COUNT_ERROR"] = "GET WARRANTY ADMIN TABLE TOTAL COUNT ERROR";
        ActionTypes["GET_WARRANTY_ADMIN_BUYER_TABLE_TOTAL_COUNT"] = "GET WARRANTY ADMIN BUYER TABLE TOTAL COUNT";
        ActionTypes["GET_WARRANTY_ADMIN_BUYER_TABLE_TOTAL_COUNT_SUCCESS"] = "GET WARRANTY ADMIN BUYER TABLE TOTAL COUNT SUCCESS";
        ActionTypes["GET_WARRANTY_ADMIN_BUYER_TABLE_TOTAL_COUNT_ERROR"] = "GET WARRANTY ADMIN BUYER TABLE TOTAL COUNT ERROR";
        ActionTypes["GET_WARRANTY_ADMIN_SELLER_TABLE_TOTAL_COUNT"] = "GET WARRANTY ADMIN SELLER TABLE TOTAL COUNT";
        ActionTypes["GET_WARRANTY_ADMIN_SELLER_TABLE_TOTAL_COUNT_SUCCESS"] = "GET WARRANTY ADMIN SELLER TABLE TOTAL COUNT SUCCESS";
        ActionTypes["GET_WARRANTY_ADMIN_SELLER_TABLE_TOTAL_COUNT_ERROR"] = "GET WARRANTY ADMIN SELLER TABLE TOTAL COUNT ERROR";
        ActionTypes["GET_WARRANTY_ADMIN_ARCHIVE_TABLE_TOTAL_COUNT"] = "GET WARRANTY ADMIN ARCHIVE TABLE TOTAL COUNT";
        ActionTypes["GET_WARRANTY_ADMIN_ARCHIVE_TABLE_TOTAL_COUNT_SUCCESS"] = "GET WARRANTY ADMIN ARCHIVE TABLE TOTAL COUNT SUCCESS";
        ActionTypes["GET_WARRANTY_ADMIN_ARCHIVE_TABLE_TOTAL_COUNT_ERROR"] = "GET WARRANTY ADMIN ARCHIVE TABLE TOTAL COUNT ERROR";
        ActionTypes["GET_DAMAGES_ADMIN_TOTAL_COUNT"] = "GET DAMAGES ADMIN TOTAL COUNT";
        ActionTypes["GET_DAMAGES_ADMIN_TOTAL_COUNT_SUCCESS"] = "GET DAMAGES ADMIN TOTAL COUNT SUCCESS";
        ActionTypes["GET_DAMAGES_ADMIN_TOTAL_COUNT_ERROR"] = "GET DAMAGES ADMIN TOTAL COUNT ERROR";
        ActionTypes["GET_BUYERS_ADMIN_TOTAL_COUNT"] = "GET BUYERS ADMIN TOTAL COUNT";
        ActionTypes["GET_BUYERS_ADMIN_TOTAL_COUNT_SUCCESS"] = "GET BUYERS ADMIN TOTAL COUNT SUCCESS";
        ActionTypes["GET_BUYERS_ADMIN_TOTAL_COUNT_ERROR"] = "GET BUYERS ADMIN TOTAL COUNT ERROR";
        ActionTypes["GET_SELLERS_ADMIN_TOTAL_COUNT"] = "GET SELLERS ADMIN TOTAL COUNT";
        ActionTypes["GET_SELLERS_ADMIN_TOTAL_COUNT_SUCCESS"] = "GET SELLERS ADMIN TOTAL COUNT SUCCESS";
        ActionTypes["GET_SELLERS_ADMIN_TOTAL_COUNT_ERROR"] = "GET SELLERS ADMIN TOTAL COUNT ERROR";
        ActionTypes["GET_SELLERS_UNACTIVE_ADMIN_TOTAL_COUNT"] = "GET SELLERS UNACTIVE ADMIN TOTAL COUNT";
        ActionTypes["GET_SELLERS_UNACTIVE_ADMIN_TOTAL_COUNT_SUCCESS"] = "GET SELLERS UNACTIVE ADMIN TOTAL COUNT SUCCESS";
        ActionTypes["GET_SELLERS_UNACTIVE_ADMIN_TOTAL_COUNT_ERROR"] = "GET SELLERS UNACTIVE ADMIN TOTAL COUNT ERROR";
        ActionTypes["GET_OTHER_ACTIVE_SELLERS_TOTAL_COUNT"] = "GET OTHER ACTIVE SELLERS TOTAL COUNT";
        ActionTypes["GET_OTHER_ACTIVE_SELLERS_TOTAL_COUNT_SUCCESS"] = "GET OTHER ACTIVE SELLERS TOTAL COUNT SUCCESS";
        ActionTypes["GET_OTHER_ACTIVE_SELLERS_TOTAL_COUNT_ERROR"] = "GET OTHER ACTIVE SELLERS TOTAL COUNT ERROR";
        ActionTypes["GET_MARKETING_SELLERS_TABLE_TOTAL_COUNT"] = "GET MARKETING SELLERS TABLE TOTAL COUNT";
        ActionTypes["GET_MARKETING_SELLERS_TABLE_TOTAL_COUNT_SUCCESS"] = "GET MARKETING SELLERS TABLE TOTAL COUNT SUCCESS";
        ActionTypes["GET_MARKETING_SELLERS_TABLE_TOTAL_COUNT_ERROR"] = "GET MARKETING SELLERS TABLE TOTAL COUNT ERROR";
        ActionTypes["GET_SELLERS_TABLE"] = "GET SELLERS TABLE";
        ActionTypes["GET_SELLERS_TABLE_SUCCESS"] = "GET SELLERS TABLE SUCCESS";
        ActionTypes["GET_SELLERS_TABLE_ERROR"] = "GET SELLERS TABLE ERROR";
        ActionTypes["GET_MARKETING_SELLERS_TABLE"] = "GET MARKETING SELLERS TABLE";
        ActionTypes["GET_MARKETING_SELLERS_TABLE_SUCCESS"] = "GET MARKETING SELLERS TABLE SUCCESS";
        ActionTypes["GET_MARKETING_SELLERS_TABLE_ERROR"] = "GET MARKETING SELLERS TABLE ERROR";
        ActionTypes["GET_SELLERS_UNACTIVE_TABLE"] = "GET SELLERS UNACTIVE TABLE";
        ActionTypes["GET_SELLERS_UNACTIVE_TABLE_SUCCESS"] = "GET SELLERS UNACTIVE TABLE SUCCESS";
        ActionTypes["GET_SELLERS_UNACTIVE_TABLE_ERROR"] = "GET SELLERS UNACTIVE TABLE ERROR";
        ActionTypes["GET_OTHER_ACTIVE_SELLERS_TABLE"] = "GET OTHER ACTIVE SELLERS TABLE";
        ActionTypes["GET_OTHER_ACTIVE_SELLERS_TABLE_SUCCESS"] = "GET OTHER ACTIVE SELLERS TABLE SUCCESS";
        ActionTypes["GET_OTHER_ACTIVE_SELLERS_TABLE_ERROR"] = "GET OTHER ACTIVE SELLERS TABLE ERROR";
        ActionTypes["GET_STATISTICS_MARKETING_WARRANTIES_TABLE"] = 'GET STATISTICS MARKETING WARRANTIES TABLE';
        ActionTypes["GET_STATISTICS_MARKETING_WARRANTIES_TABLE_SUCCESS"] = 'GET STATISTICS MARKETING WARRANTIES SUCCESS';
        ActionTypes["GET_STATISTICS_MARKETING_WARRANTIES_TABLE_ERROR"] = 'GET STATISTICS MARKETING WARRANTIES ERROR';
        ActionTypes["GET_STATISTICS_WARRANTIES_TABLE"] = 'GET STATISTICS WARRANTIES TABLE';
        ActionTypes["GET_STATISTICS_WARRANTIES_TABLE_SUCCESS"] = 'GET STATISTICS WARRANTIES SUCCESS';
        ActionTypes["GET_STATISTICS_WARRANTIES_TABLE_ERROR"] = 'GET STATISTICS WARRANTIES ERROR';
        ActionTypes["SUBMIT_SELLER_CONTRACT"] = "SUBMIT SELLER CONTRACT";
        ActionTypes["SUBMIT_SELLER_CONTRACT_SUCCESS"] = "SUBMIT SELLER CONTRACT SUCCESS";
        ActionTypes["SUBMIT_SELLER_CONTRACT_ERROR"] = "SUBMIT SELLER CONTRACT ERROR";
        ActionTypes["CANCEL_SELLER_CONTRACT"] = "CANCEL SELLER CONTRACT";
        ActionTypes["CANCEL_SELLER_CONTRACT_SUCCESS"] = "CANCEL SELLER CONTRACT SUCCESS";
        ActionTypes["CANCEL_SELLER_CONTRACT_ERROR"] = "CANCEL SELLER CONTRACT ERROR";
        ActionTypes["DENIED_SELLER_CONTRACT"] = "DENIED SELLER CONTRACT";
        ActionTypes["DENIED_SELLER_CONTRACT_SUCCESS"] = "DENIED SELLER CONTRACT SUCCESS";
        ActionTypes["DENIED_SELLER_CONTRACT_ERROR"] = "DENIED SELLER CONTRACT ERROR";
        ActionTypes["GET_LEGAL_BUYERS"] = "GET LEGAL BUYERS";
        ActionTypes["GET_LEGAL_BUYERS_SUCCESS"] = "GET LEGAL BUYERS SUCCESS";
        ActionTypes["GET_LEGAL_BUYERS_ERROR"] = "GET LEGAL BUYERS ERROR";
        ActionTypes["CHANGE_WARRANTY_DURATION"] = "CHANGE WARRANTY DURATION";
        ActionTypes["CHANGE_WARRANTY_DURATION_SUCCESS"] = "CHANGE WARRANTY DURATION SUCCESS";
        ActionTypes["CHANGE_WARRANTY_DURATION_ERROR"] = "CHANGE WARRANTY DURATION ERROR";
        ActionTypes["GET_LAST_YEAR_THIS_MONTH_STATISTIC"] = "GET LAST YEAR THIS MONTH STATISTIC";
        ActionTypes["GET_LAST_YEAR_THIS_MONTH_STATISTIC_SUCCESS"] = "GET LAST YEAR THIS MONTH STATISTIC SUCCESS";
        ActionTypes["GET_LAST_YEAR_THIS_MONTH_STATISTIC_ERROR"] = "GET LAST YEAR THIS MONTH STATISTIC ERROR";
    })(ActionTypes || (ActionTypes = {}));
    ;
    exports["default"] = ActionTypes;
});
//# sourceMappingURL=ActionTypes.js.map